/**
 * O que faz: Converte registros da tabela blog_posts para o formato usado pelos componentes publicos.
 * Onde usa: Paginas publicas do blog e dados estruturados de SEO.
 * Conexoes: Recebe BlogPost vindo do Supabase e entrega PublicContentItem para UI/schema.
 * Tabelas: blog_posts (campos lidos por useBlogPosts/useBlogPost).
 * Data: 11/05/2026
 */

import type { BlogPost, PublicContentItem } from "@/content/types";

export function mapBlogPostToPublicContentItem(post: BlogPost): PublicContentItem {
  return {
    type: post.type,
    slug: post.slug,
    title: post.title,
    description: post.description,
    category: post.category,
    audience: post.audience,
    publishedAt: post.published_at,
    updatedAt: post.updated_at,
    status: "approved",
    ctaContext: post.cta_context || post.title,
    faqs: post.faqs ?? [],
    sources: post.sources ?? [],
    body: post.body,
    url: post.type === "blog" ? `/blog/${post.slug}` : `/${post.slug}`,
  };
}
